import React, { useState } from "react";
import { BsChevronDown } from "react-icons/bs";
import { FaTimes } from "react-icons/fa";
import { useCreateClinicalSite } from "../../hooks/useCreateClinicalSite";

const NewClinicalSite = () => {
  const [country, setCountry] = useState("");
  const [countryIcon, setCountryIcon] = useState(false);
  const [facility, setFacility] = useState("");
  const [facilityIcon, setFacilityIcon] = useState(false);

  // Form state
  const [formData, setFormData] = useState({
    name: "",
    city: "",
    province: "",
    postalCode: "",
    streetAddress: "",
    suite: "",
    phoneNumber: "",
    extension: "",
  });

  const createClinicalSiteMutation = useCreateClinicalSite();

  const countryIconRotate = countryIcon ? "rotate(180deg)" : "rotate(0)";
  const facilityIconRotate = facilityIcon ? "rotate(180deg)" : "rotate(0)";
  const handleCountry = (selected) => {
    setCountry(selected);
  };
  const handleFacility = (selected) => {
    setFacility(selected);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Get organization ID from localStorage
    const user = JSON.parse(localStorage.getItem("user"));
    const organizationId = user?.organizations?.[0]?.id;

    if (!organizationId) {
      console.error("Organization ID not found");
      return;
    }

    const clinicalSiteData = {
      organizationId,
      name: formData.name,
      city: formData.city,
      province: formData.province,
      country: country,
      postalCode: formData.postalCode,
      streetAddress: formData.streetAddress,
      suite: formData.suite,
      phoneNumber: formData.phoneNumber,
      facilityType: facility,
    };

    try {
      await createClinicalSiteMutation.mutateAsync(clinicalSiteData);
      // Reset form after successful submission
      setFormData({
        name: "",
        city: "",
        province: "",
        postalCode: "",
        streetAddress: "",
        suite: "",
        phoneNumber: "",
        extension: "",
      });
      setCountry("");
      setFacility("");

      // Close modal with a small delay to allow toast to appear
      setTimeout(() => {
        if (window.$ && window.$("#newClinicalSite").modal) {
          window.$("#newClinicalSite").modal("hide");
        } else {
          // Fallback: trigger close button click
          const closeButton = document.querySelector(
            '#newClinicalSite [data-dismiss="modal"]'
          );
          if (closeButton) {
            closeButton.click();
          }
        }
      }, 100);
    } catch (error) {
      console.error("Failed to create clinical site:", error);
    }
  };
  return (
    <div
      className="modal fade"
      id="newClinicalSite"
      tabindex="-1"
      aria-labelledby="newClinicalSite"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <form onSubmit={handleSubmit}>
          <div className="modal-content border-0 overlay-rounded">
            <div className="modal-header mt-14 border-0">
              <label className="fs-15 text_primary" id="newCLinicalSite">
                CREATE: New Clinical Site
              </label>

              <FaTimes
                size={15}
                className="cursor-pointer text_primary"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="container-fluid p-0">
                <div className="row">
                  <div className="col-md-6 small-text">
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        Clinical Site Name:
                      </label>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          className="small-text overlay-input"
                          placeholder="Enter Clinical Site Name"
                          required
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">City:</label>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="city"
                          value={formData.city}
                          onChange={handleInputChange}
                          className="small-text overlay-input"
                          placeholder="Enter City"
                          required
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        Province:
                      </label>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="province"
                          value={formData.province}
                          onChange={handleInputChange}
                          className="small-text overlay-input"
                          placeholder="Enter Province"
                          required
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        Country:
                      </label>
                      <div className="col-md-8 ">
                        <div className="dropdown">
                          <div className="dropdown">
                            <button
                              className="btn btn-block border text-left h-35 w-205"
                              type="button"
                              id="dropdownMenuButton"
                              data-toggle="dropdown"
                              data-display="static"
                              aria-haspopup="true"
                              aria-expanded="false"
                              onClickCapture={() =>
                                setCountryIcon(!countryIcon)
                              }
                            >
                              <div className="d-flex justify-content-between">
                                <small className="small-text">
                                  {country ? country : "Choose Country"}
                                </small>
                                <BsChevronDown
                                  style={{
                                    transform: countryIconRotate,
                                    transition: "all 0.3s linear",
                                  }}
                                />
                              </div>
                            </button>
                            <div
                              className="dropdown-menu dropdown-menu--animate custom border-0 shadow overlay-dropdown-container w-205"
                              aria-labelledby="dropdownMenuButton"
                            >
                              <p className="pl-4 mb-0 pb-2">
                                <small>Choose one country only:</small>
                              </p>

                              <a
                                onClick={() => handleCountry("Canada")}
                                className="dropdown-item activeHover ml-4 wa"
                                href="#"
                              >
                                <small>Canada</small>
                              </a>
                              <a
                                onClick={() => handleCountry("United States")}
                                className="dropdown-item activeHover ml-4 wa"
                                href="#"
                              >
                                <small>United States</small>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        Postal Code:
                      </label>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="postalCode"
                          value={formData.postalCode}
                          onChange={handleInputChange}
                          className="small-text overlay-input"
                          placeholder="Enter Postal Code"
                          required
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        Street Address:
                      </label>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="streetAddress"
                          value={formData.streetAddress}
                          onChange={handleInputChange}
                          className="small-text overlay-input"
                          placeholder="Enter Street Address"
                          required
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">Suite:</label>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="suite"
                          value={formData.suite}
                          onChange={handleInputChange}
                          className="small-text overlay-input"
                          placeholder="Enter Suite (if applicable)"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 small-text">
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        Phone Number:
                      </label>
                      <div className="col-md-8">
                        <input
                          type="tel"
                          name="phoneNumber"
                          value={formData.phoneNumber}
                          onChange={handleInputChange}
                          className="small-text overlay-input"
                          placeholder="Enter Phone Number"
                          required
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        Extension:
                      </label>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="extension"
                          value={formData.extension}
                          onChange={handleInputChange}
                          className="small-text overlay-input"
                          placeholder="Enter Extension (if applicable)"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        Type of Healthcare Facility:
                      </label>
                      <div className="col-md-8">
                        <div className="dropdown">
                          <div className="dropdown">
                            <button
                              className="btn btn-block border text-left h-35 w-205"
                              type="button"
                              id="dropdownMenuButton"
                              data-toggle="dropdown"
                              data-display="static"
                              aria-haspopup="true"
                              aria-expanded="false"
                              onClickCapture={() =>
                                setFacilityIcon(!facilityIcon)
                              }
                            >
                              <div className="d-flex justify-content-between">
                                <small className="small-text">
                                  {facility
                                    ? facility
                                    : "Choose type of Facility"}
                                </small>
                                <BsChevronDown
                                  style={{
                                    transform: facilityIconRotate,
                                    transition: "all 0.3s linear",
                                  }}
                                />
                              </div>
                            </button>
                            <div
                              className="dropdown-menu dropdown-menu--animate custom border-0 shadow overlay-dropdown-container w-205"
                              aria-labelledby="dropdownMenuButton"
                            >
                              <p className="pl-4 mb-0 pb-2">
                                <small>Choose one:</small>
                              </p>

                              <a
                                onClick={() =>
                                  handleFacility(
                                    "AMBULATORY_HEALTHCARE_SERVICES"
                                  )
                                }
                                className="dropdown-item activeHover ml-4 wa"
                                href="#"
                              >
                                <small>Ambulatory Healthcare Services</small>
                              </a>
                              <a
                                onClick={() => handleFacility("HOSPITAL")}
                                className="dropdown-item activeHover ml-4 wa"
                                href="#"
                              >
                                <small>Hospital</small>
                              </a>
                              <a
                                onClick={() =>
                                  handleFacility("NURSING_AND_RESIDENTIAL_CARE")
                                }
                                className="dropdown-item activeHover ml-4 wa"
                                href="#"
                              >
                                <small>
                                  Nursing & Residential Care Facility
                                </small>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">Image:</label>
                      <div className="col-md-8">
                        <input
                          type="file"
                          className="small-text overlay-input"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">Logo:</label>
                      <div className="col-md-8">
                        <input
                          type="file"
                          className="small-text overlay-input"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer border-0 d-flex justify-content-between">
              <button
                type="button"
                className="btn btn_outline_danger rounded overlay-btn"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-outline-primary rounded overlay-btn"
                disabled={createClinicalSiteMutation.isPending}
              >
                {createClinicalSiteMutation.isPending
                  ? "Creating..."
                  : "Save changes"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewClinicalSite;
